import React from 'react'
import { Route, Switch } from 'react-router-dom'
import * as routes from 'constants/routes'

import ErrorBoundary from "components/ErrorBoundary";
import CoreLayout from 'layouts/CoreLayout'

import CustomersRoutes from './Modules/Customers'
import EquipmentsRoutes from './Modules/Equipments'
import RegionsRoutes from './Modules/Regions'
import NotificationsRoutes from './Modules/Notifications'
import SchedulerRoutes from './Modules/Scheduler'

import DashboardPage from 'containers/Dashboard'

// const HomePage = () => (<h2>HomePage</h2>)
// const DashboardPage = () => (<h2>DashboardPage</h2>)
const AccountsPage = () => (<h2>User Profile Page</h2>)

function ApplicationRoutes(props) {
  return (
    <CoreLayout>
      <ErrorBoundary>
        <Switch>
          <Route exact path={routes.HOME} component={DashboardPage} />
          <Route path={routes.ACCOUNT} component={AccountsPage} />
          <Route path={routes.DASHBOARD} component={DashboardPage} />
          <Route path={routes.CUSTOMERS} component={CustomersRoutes} />
          <Route path={routes.EQUIPMENTS} component={EquipmentsRoutes} />
          <Route path={routes.REGIONS} component={RegionsRoutes} />
          <Route path={routes.NOTIFICATIONS} component={NotificationsRoutes} />
          <Route path={routes.SCHEDULER} component={SchedulerRoutes} />
        </Switch>
      </ErrorBoundary>
    </CoreLayout>
  )
}

export default ApplicationRoutes



